<template>
  <v-app id="app">
    <router-view></router-view>
    <Loader></Loader>
  </v-app>
</template>

<script>

import Loader from './components/shared/Loader.vue';
import companyService from "@/services/CompanyService";

  export default {
    name: 'App',
    data: () => ({}),
    props: {
      source: String
    },
    components: {
      Loader,
    },
    mounted(){
      let uuid;
      const token = localStorage.getItem('token');
      const companyId = localStorage.getItem('companyId');
      if (token && companyId) {
        companyService.getCompanyInfo(companyId).then(resp => {
          this.$store.commit('setCompany', resp.data.data);
        }).catch(err => console.error(err));
      }
      if(localStorage.device_id !== undefined &&
         localStorage.device_id !== ''){
        uuid = localStorage.device_id
      } else {
        uuid = this.$uuid.v1()
        localStorage.device_id = uuid
      }
    }
  }
</script>

<style lang="scss">
@import "./assets/stylesheets/application.scss";
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100..900&display=swap');

html {
  overflow-y: auto !important;
}

body {
  font-family: "Monserrat", sans-serif!important;
  .v-list__tile__title {
    font-family: "Monserrat", sans-serif!important;
  }

}
</style>
